import { render, staticRenderFns } from "./addChangeNeedTwo.vue?vue&type=template&id=7fc9bb83&scoped=true&"
import script from "./addChangeNeedTwo.vue?vue&type=script&lang=js&"
export * from "./addChangeNeedTwo.vue?vue&type=script&lang=js&"
import style0 from "./addChangeNeedTwo.vue?vue&type=style&index=0&id=7fc9bb83&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc9bb83",
  null
  
)

export default component.exports